import React from 'react'
import tw from 'tailwind-styled-components'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {cn} from '@containers/html-utils'
import {ArrowButton, Direction} from './arrow-button'
import {MenuButtonContainer} from './menu-button-container'
import {MenuIconPlain} from './menu-icon-plain'

interface Props {
  active?: boolean
  onClick?: () => void
  text: string
  count?: string
  countMarked?: boolean
  icon: TablerIcons
  withArrow?: boolean
  arrowCb?: (e: React.MouseEvent) => void
  arrowDirection?: Direction
  className?: string
  after?: React.ReactNode
}

export const MenuButtonWithContent = (props: Props) => {
  const {active, onClick, text, count, icon, className} = props
  const {withArrow, arrowDirection, arrowCb, countMarked, after} = props

  return (
    <MenuButtonContainer
      $active={active}
      onClick={onClick}
      className={cn(className, count && 'pr-12', withArrow && 'pr-8')}
    >
      <MenuIconPlain icon={icon} className="mr-8" />

      <TwTextButton>{text}</TwTextButton>

      {count && <TwCounter $marked={countMarked}>{count}</TwCounter>}
      {withArrow && (
        <ArrowButton
          className="ml-auto"
          cb={arrowCb}
          direction={arrowDirection}
        />
      )}
      {after}
    </MenuButtonContainer>
  )
}

const TwTextButton = tw.div`
  select-none
  text-14
  leading-4
  text-panel-text-primary
  whitespace-nowrap
`

type TwCounterType = {
  $marked?: boolean
}

const TwCounter = tw.div<TwCounterType>`
  text-11
  leading-4
  ml-auto
  font-normal
  ${p =>
    p.$marked ? 'text-notification-primary' : 'text-panel-text-secondary'}
`
